import React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { Waypoint } from 'react-waypoint';
import { ButtonPrimary, ElementLoader } from 'ui';
import { deepEquals } from 'app/infrastructure/js';
import { SearchFilters } from 'app/area/search-filters/search-filters';
import { SerializePayload } from 'app/area/search-filters/types';
import { SubscriberGroupsSearchModel, ListRendererProps } from '../types-store';
import { serialize } from '../serialize';
import { ListResults } from './list-results';
import { routeConstants } from 'app/routes/route-constants';
import { subscriberGroupFilters } from 'app/area/subscriber-groups/list/filter-configuration';
import styles from './list-renderer.scss';

export const ListRenderer: React.FC<ListRendererProps> = ({
  listState, mergeSubscriberGroup, translation, loadList, updateMergeSubscriberGroup
}) => {

  const { fetching, requestedSearchModel, listItems, numberOfResults } = listState;

  const updateSearchModel = (payload: SerializePayload) => {
    onLoadData(serialize(payload));
  };

  const onLoadData = (searchModel: SubscriberGroupsSearchModel, startIndex?: number) => {

    if (startIndex !== undefined || !deepEquals(searchModel, requestedSearchModel)) {
      loadList(searchModel, startIndex);
    }
  };

  const onFetchMore = () => {

    if (fetching || !listItems || listItems.length === 0 || listItems.length === numberOfResults) {
      return;
    }

    onLoadData(requestedSearchModel, listItems.length);
  };

  const onCreate = () =>
    navigate.replace(routeConstants.subscriberGroupsAddFor());

  const topToolbar = <div className="row">
    <h1 className="col-12">
      {translation.subscriber_groups}
    </h1>
  </div>;

  const rightToolbar = <ButtonPrimary
    id={'add-new-subscriber-group'}
    onClick={onCreate}>
    {translation.add_new}
  </ButtonPrimary>;

  return <>
    <SearchFilters
      topToolbar={topToolbar}
      rightToolbar={rightToolbar}
      filtersConfig={{ area: 'subscriberGroups' }}
      queryFilters={undefined}
      predefinedFilters={undefined}
      customFilters={subscriberGroupFilters(translation)}
      defaultFilterValues={undefined}
      updateSearchModel={updateSearchModel}>
      {!!listItems && <div className="row">
        <div className="col-12">
          <div id="subscriber_groups_number_of_results"
            className={styles.noOfResults}>
            {numberOfResults === 0
              ? translation.search_no_subscriber_groups
              : `${numberOfResults} ${translation.search_hits}`}
          </div>
        </div>
      </div>}
      {listItems && listItems.length > 0
        ? <ListResults
          updateMergeSubscriberGroup={updateMergeSubscriberGroup}
          mergeSubscriberGroup={mergeSubscriberGroup}
          listItems={listItems}
          translation={translation} />
        : null}
      <Waypoint key="wpSubscriberGroupsAdmin" onEnter={onFetchMore} scrollableAncestor={window} bottomOffset="-10%" />
      {listState.fetching ? <ElementLoader /> : null}
    </SearchFilters>
  </>;
};
